import * as React from 'react'
import PropTypes from 'prop-types'

import resolveAssetURL from '@/utils/resolveAssetURL'

import {
  ImageWrapper
} from './style'

const ArticleBlockImage = ({
  src = ''
}) => {
  return (
    <ImageWrapper loading='lazy' img={ resolveAssetURL(src) } />
  )
}

ArticleBlockImage.propTypes = {
  src: PropTypes.string
}

export default ArticleBlockImage
